import React from "react";
import PropTypes from "prop-types";

import {getTemporalRuleDescription, getRulePeriod, FILTER_KEYS} from "../../../../../services/filterRules";
import {DateFormatter} from "../../../../../services/date"

import {Badge, Box, Grid, IconButton, Typography} from "@mui/material";
import Divider from "@mui/material/Divider";

import DeleteIcon from "@mui/icons-material/Delete";
import MailIcon from '@mui/icons-material/Mail';


const TemporalRules = props => {
    const {rules, text, onShowRequests, onDelete} = props;


    const handleDelete = (ruleId) => (event) => {
        event.preventDefault();
        onDelete(ruleId, true)
    };

    const handleShowRequests = (ruleId) => (event) => {
        event.preventDefault();
        onShowRequests(ruleId)
    };

    return (
        <Grid container
              direction="column">

            <Grid item>
                <Box sx={{py: 2}}>
                    <Typography variant="body1">
                        {text}
                    </Typography>
                </Box>
            </Grid>

            <Grid item container>
                {
                    rules.map((r,i) => {
                        const [from, to] = getRulePeriod(r);
                        const description = getTemporalRuleDescription(r);
                        const totalFilteredRequestsNotOld = r[FILTER_KEYS.totalFilteredRequestsNotOld];

                        return (
                            <React.Fragment key={r.id}>
                                {
                                    i === 0 &&
                                    <Divider sx={{width: "100%"}}/>
                                }
                                <Grid item
                                      container
                                      sx={{p: 1}}>

                                    <Grid item
                                          xs={12} sm={9} md={10}
                                          container
                                          direction="column"
                                          justifyContent="center">

                                        <Grid item>
                                            <Typography variant="subtitle1">
                                                Dal
                                                <Box component="span" sx={{px: 1, fontWeight: 500}}>
                                                    {DateFormatter.shortString(from)}
                                                </Box>
                                                al
                                                <Box component="span" sx={{px: 1, fontWeight: 500}}>
                                                    {DateFormatter.shortString(to)}
                                                </Box>
                                            </Typography>
                                        </Grid>

                                        {description &&
                                        <Grid item>
                                            <Typography variant="body1">
                                                {description}
                                            </Typography>
                                        </Grid>
                                        }
                                    </Grid>

                                    <Grid item xs={12} sm={3} md={2}>
                                        <Box sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            height: "100%"
                                        }}>
                                            <IconButton
                                                aria-label="Richieste filtrate"
                                                onClick={handleShowRequests(r.id)}>
                                                <Badge color="primary" badgeContent={totalFilteredRequestsNotOld}
                                                       max={99}>
                                                    <MailIcon/>
                                                </Badge>
                                            </IconButton>

                                            <IconButton
                                                aria-label="Cancella"
                                                onClick={handleDelete(r.id)}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                </Grid>
                                <Divider sx={{width: "100%"}} />
                            </React.Fragment>
                        )
                    })
                }
            </Grid>
        </Grid>
    )
};

TemporalRules.propTypes = {
    rules: PropTypes.arrayOf(PropTypes.object).isRequired,
    text: PropTypes.string.isRequired,
    onShowRequests: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export {TemporalRules}